import { getById, getBySlug } from '@apps/utils/contentful'

/**
 * How long the billing address field waits after the last keystroke before
 * searching. Read from Contentful so it can be tuned without a release, the same
 * way get-serviceFee911-attempt is.
 *
 * The value lives on commonElements because both card components use it and it
 * is not copy. Contentful returns short text fields as strings; the coercion
 * here is what allows a missing, non-numeric or non-positive value to fall back
 * to the shipped default rather than reaching setTimeout as NaN or as a zero
 * that disables the wait entirely.
 */
export const ADDRESS_SEARCH_DEBOUNCE_FALLBACK_MS = 300

export const getAddressSearchDebounceMs = (pageContent, language) => {
  const commonShort = getById(pageContent, 'commonElements')?.[language]?.shortTextFields
  const configured = Number(getBySlug(commonShort, 'address-search-debounce-ms')?.value)

  return Number.isFinite(configured) && configured > 0
    ? configured
    : ADDRESS_SEARCH_DEBOUNCE_FALLBACK_MS
}
